import React from "react";
import {FormattedMessage} from 'react-intl';
import {ApiResponse} from "@models/axios";
import __i18n from "../intl/__i18n";

export const enum DiscountCodePolicyCalculationType {
    "FixPrice" = "fix_price",
    "Percentage"="percentage"
}

export const DiscountCodePolicyCalculationTypeOptions = [{
    value: DiscountCodePolicyCalculationType.FixPrice,
    label: <FormattedMessage id="app.fix_price" defaultMessage={`Fix Price`}/>,
}, {
    value: DiscountCodePolicyCalculationType.Percentage,
    label: <FormattedMessage id="app.percentage" defaultMessage={`Percentage`}/>,
}];



export const enum DiscountCodePolicyType {
  "ReusableDiscountCode" = "reusable_discount_code",
  "UniqueDiscountCode" = "unique_discount_code",
}


export const DiscountCodePolicyTypeOptions = [{
    value: DiscountCodePolicyType.ReusableDiscountCode,
    label: __i18n("Reusable Discount Code")
}, {
    value: DiscountCodePolicyType.UniqueDiscountCode,
    label: __i18n("Unique Discount Code")
}];


export interface DiscountCodePolicy extends ApiResponse {
    title:string;
    description:string;
    calculation_type:CalculationType;
    type:DiscountCodePolicyType;
    count:number;
    unique_identifier:string;
    prefix:string;
    valid_from:string;
    valid_to:string;
    max_usage_count:number;
    amount:number;
    max_value:number;
    package_payment_approach_id:string;
}

export interface DiscountCodePolicyState {
    readonly loading: boolean;
    readonly data: DiscountCodePolicy[];
    readonly errors?: string;
    readonly count: number
}
